import React from "react";

import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import ScrollIndicator from "../../Home/ScrollIndicator";
import useScrollToTop from "../../../hooks/useScollToTop";

import ScoreboardAndroidCard from "./components/ScoreboardAndroidCard";
import ScoreboardHero from "./components/ScoreboardHero";
import ScoreboardOnlineCard from "./components/ScoreboardOnlineCard";
import ScoreboardScreensCarousel from "./components/ScoreboardScreensCarousel";
import ScoreboardStats from "./components/ScoreboardStats";

import {
  ANDROID_SCOREBOARD,
  ONLINE_SCOREBOARD,
  SCOREBOARD_SCREENSHOTS,
} from "./utils/scoreboardUtils";

function JudoScorePro() {
  useScrollToTop();

  return (
    <main className="min-h-screen bg-slate-50 pb-24 pt-[88px] text-slate-950 dark:bg-slate-950 dark:text-white lg:pt-[104px]">
      <ScoreboardHero />

      <section className="mx-auto -mt-12 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <div className="rounded-[2rem] border border-white/80 bg-white/95 p-4 shadow-2xl shadow-slate-200/70 backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/95 dark:shadow-black/30 sm:p-6">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-blue-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-blue-700 dark:bg-blue-500/10 dark:text-blue-200">
              Arbitrage & score
            </div>

            <h1 className="mt-4 font-titre text-3xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-4xl">
              Deux solutions pour tenir les scores de judo
            </h1>

            <p className="mt-3 max-w-3xl text-sm font-medium leading-7 text-slate-600 dark:text-white/60 sm:text-base">
              Utilise directement le tableau de score en ligne depuis un
              navigateur, ou installe l'application Android JudoScore Pro pour
              gérer tes combats sur smartphone ou tablette.
            </p>
          </div>

          <ScoreboardStats />
        </div>
      </section>

      <section className="mx-auto mt-6 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <div className="grid gap-6 xl:grid-cols-[1.15fr_0.85fr]">
          <ScoreboardOnlineCard scoreboard={ONLINE_SCOREBOARD} />
          <ScoreboardAndroidCard scoreboard={ANDROID_SCOREBOARD} />
        </div>

        <ScoreboardScreensCarousel screenshots={SCOREBOARD_SCREENSHOTS} />
      </section>

      <DashboardNavigation />
      <ScrollIndicator />
    </main>
  );
}

export default JudoScorePro;